import { useSelector } from "react-redux";
import { langSelector } from "../store/langSlice";

export default function useLang() {
  const lang = useSelector(langSelector);
  return { ...lang, t:(key)=>lang?.[key] || key };
}


